import { render, staticRenderFns } from "./ServiceExtension.vue?vue&type=template&id=85fa7e82&scoped=true&"
import script from "./ServiceExtension.vue?vue&type=script&lang=js&"
export * from "./ServiceExtension.vue?vue&type=script&lang=js&"
import style0 from "./ServiceExtension.vue?vue&type=style&index=0&id=85fa7e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fa7e82",
  null
  
)

export default component.exports